var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status),expression:"status"}],staticClass:"sl-spinner",style:(_vm.spinnerStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }